export default __webpack_public_path__ + "static/media/user_selected.92d0edd0.svg";